import EnteringExitingWarehouse from "models/entering-exiting-warehouse";
export default {
  data() {
    return {
      projectList: [],
    }
  },
  created() {
  },
  methods: {
    //获取进出仓项目列表数据
    initEnterExitWarehouseProjectData() {
      let code = '';
      let name = '';
      let data = {
        code,
        name
      }
      EnteringExitingWarehouse.getEnteringExitingWarehouseList(data).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.status = value.status;
            arr.push(obj);
          });
          this.projectList = arr;
        }
      });
    }
  }
}